var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classNames from 'classnames';
import { withTranslation } from 'react-i18next';
import { MyTextArea } from '../../../../../Base/Form';
import './GeneratorInput.scss';
const GeneratorInput = (props) => {
    const { text, onChange, placeholder, placeholderParams, additionalStyles, disabled, t, options, emojiPicker } = props;
    const _a = (options || {}), { size: _size } = _a, textareaOptions = __rest(_a, ["size"]);
    return (React.createElement(MyTextArea, { placeholderText: placeholder ? t(`${placeholder}`, placeholderParams) : '', text: text, setText: onChange, containerClassName: classNames('generator-input-textbox', additionalStyles), emojiPicker: emojiPicker, textareaProps: Object.assign({ disabled, autoSize: { minRows: 1, maxRows: 6 } }, textareaOptions) }));
};
export default withTranslation()(GeneratorInput);
